module.exports = __webpack_public_path__ + "img/empfang.2aa82c0f.jpg";